import { useEffect, useState } from 'react';
import { Network } from '@capacitor/network';

export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    let removeFn: (() => void) | undefined;
    void (async () => {
      const status = await Network.getStatus();
      setOnline(status.connected);
      const handle = await Network.addListener('networkStatusChange', (s) =>
        setOnline(s.connected),
      );
      removeFn = () => void handle.remove();
    })();
    return () => {
      if (removeFn) removeFn();
    };
  }, []);

  return online;
}
